// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn .v-btn__content{color:#fff}*{margin:0;border:0;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box}body,html{width:100%;color:#657180;overflow:hidden}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
